import { render } from "./JournalStartAnimation.vue?vue&type=template&id=5aa95a0d&scoped=true"
import script from "./JournalStartAnimation.vue?vue&type=script&lang=js"
export * from "./JournalStartAnimation.vue?vue&type=script&lang=js"

import "./JournalStartAnimation.vue?vue&type=style&index=0&id=5aa95a0d&scoped=true&lang=css"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa95a0d"]])

export default __exports__